<template>
    <main>
        <header class="banner solutions est-solution">
            <div class="container">
                <div class="text-left">
                    <a tag="a" href="http://epcircleenergy.com/" style="background-color: #44bd32;color:white;"class="btn "><i class="fas fa-chevron-left"></i>Go to Epcircle site</a>
                </div>
                <h1>Energy Labelling</h1>
                <h4>for high impact business</h4>
            </div>
            <div class="clip-path-one green70">
                <span class="arrow-header"></span>
            </div>
        </header>

        <section class="solution-intro">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 offset-md-2">
                        Our high-resolution EPC toolbox is based on a user-friendly and airtight mobile app for in-situ data collection, combined with a state-of-the-art energy calculation engine deployed in the cloud, that utilizes high-precision data and images from satellites to increase the accuracy of EPC.
                        <br><br>
                        We envisage that, after the initial deployment, our solution will become the industry standard due to its benefits for the reduction of Greenhouse Gas Emissions, which are a central concern of European countries.
                    </div>
                </div>
            </div>
        </section>

        <section class="solution-items">

            <solution-item v-for="(item, i) of data.solutionItems" :data="item" :number="i + 1" :key="i"></solution-item>

        </section>

       

        <section class="cta-solutions">
            <div class="container">
                <div class="row">
                    <div class="col-md-3">
                        <router-link tag="a" to="/solucoes/educacionais" class="btn btn-viitra-green"><i class="fas fa-chevron-left"></i> Go to Educational Solutions</router-link>
                    </div>
                    <div class="col-md-6">
                        <h1>want to see<br>more solutions?</h1>
                    </div>
                    <div class="col-md-3">
                        <router-link tag="a" to="/solucoes/projetos-personalizados" class="btn btn-viitra-dark">Go to Custom Projects <i class="fas fa-chevron-right"></i></router-link>
                    </div>
                </div>
            </div>
            <div class="path opacity40"></div>
            <div class="path opacity60"></div>
            <div class="path opacity80"></div>
        </section>
        
        <section class="cta-solutions mobile">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1>want to see<br>more solutions?</h1>
                    </div>
                    <div class="col-md-12">
                        <router-link tag="a" to="/solucoes/educacionais" class="btn btn-viitra-green"><i class="fas fa-chevron-left"></i> Go to Educational Solutions</router-link>
                    </div>
                    <div class="col-md-12">
                        <router-link tag="a" to="/solucoes/projetos-personalizados" class="btn btn-viitra-dark">Go to Custom Projects<i class="fas fa-chevron-right"></i></router-link>
                    </div>
                </div>
            </div>
            <div class="path opacity40"></div>
            <div class="path opacity60"></div>
            <div class="path opacity80"></div>
        </section>
    </main>
</template>

<script>
    export default {
        data() {
            return {
                data: {
                    solutionItems: [
                        {
                            title: 'EPCircle Portal',
                            description: `
                                <p>Customers hire the service and schedule the data acquisition through EPCircle Portal.</p>
                            `,
                            imageArea: {
                                type: 'image',
                                //src: '/static/images/solutions/internship_management/est-figure-12.jpg'
                            },
                        },
                        {
                            title: 'Data Acquisition',
                            description: `
                                <p>Field agent goes to the dwelling and provide the data acquisition using the App</p>
                            `,
                            imageArea: {
                                type: 'image',
                              //  src: '/static/images/solutions/internship_management/est-figure-13.jpg'
                            },
                        },
                        {
                            title: 'Calculation Engine',
                            description: `
                                <p>Engine calculates the energy efficiency by the simulation method.</p>
                            `,
                            imageArea: {
                                type: 'image',
                                //src: '/static/images/solutions/internship_management/est-figure-3.jpg'
                            },
                        },
                        {
                            title: 'Efficiency Certificate',
                            description: `
                                <p>The certificate is generated and made available on the EPCircle Portal.</p>
                            `,
                            imageArea: {
                                type: 'image',
                                //src: '/static/images/solutions/internship_management/est-figure-4.jpg'
                            },
                        },
                        {
                            title: 'Energy Saving Solutions',
                            description: `
                                <p>Local suppliers can be hired to improve the dwelling energy efficiency.</p>
                            `,
                            imageArea: {
                                type: 'image',
                                //src: '/static/images/solutions/internship_management/est-figure-7.jpg'
                            },
                        },
                      
                    ]
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/solutions/Est.vue